/**
 * LabelsContext — context object + hooks. Provider component lives in
 * `components/LabelsProvider.tsx` (separate file so this `.ts` only
 * exports types/hooks, keeping React Fast Refresh happy).
 */

import { createContext, useContext } from "react";
import type { Label } from "./types";

type EntityType = "campaign" | "ad_group";

export type LabelsByEntity = {
  campaign: Map<number, Label[]>;
  ad_group: Map<number, Label[]>;
};

export type LabelsContextValue = {
  labels: Label[];
  labelsByEntity: LabelsByEntity;
};

export const LabelsContext = createContext<LabelsContextValue | null>(null);

export function useLabelsContext(): LabelsContextValue | null {
  return useContext(LabelsContext);
}

export function useLabelsForEntity(
  entityType: EntityType,
  entityId: number | null | undefined
): Label[] {
  const ctx = useContext(LabelsContext);
  if (!ctx || entityId == null) return [];
  return ctx.labelsByEntity[entityType].get(entityId) ?? [];
}
